import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { FirebaseService } from '../service/firebase.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import autoScroll from 'dom-autoscroller';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {

  constructor() {
  }


 

  ngOnInit() {

  }


  /* TODO: Submit on form change */
  onFormChange() {

  }

}
